import React from 'react'

const BlogHero = () => {
    return (
        <div className="_blog_nft_hero_wrapper">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h1 className="_blog_nft_hero_title">Blog</h1>
                    </div>
                </div>
                <div className="_blog_nft_hero_wrap">
                    <div className="row align-items-center">
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                            <img src="assets/img/bloghero.png" alt="chobi" className="_blog_nft_hero_img" />
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                            <div className="_blog_nft_hero_right">
                                <h2 className="_blog_nft_hero_right_title">introducing seaport protocol</h2>
                                <p className="_blog_nft_hero_right_txt">It is a long established fact that a reader will be
                                    distracted by the readable content of
                                    a page when looking at its layout. The point of using </p>
                                <a href="#0" className="_blog_nft_hero_right_link">View Post</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BlogHero;